<div class="compose-email-container">
  <div class="menu">
  <span class="menu-heading">{{ Heading }}</span>
  <span class="close" (click)="closeTaskSelectionMenu()">X</span>
</div>
<div *ngIf="selectTo == false; else elsePart">
  <!-- <div class="" style="padding-top: 0.625rem"> -->
    <div class="compose-body">
    <div class="container-fluid" style="padding-bottom: 0.625rem">
      <div class="row">
        <div class="col-1">
          <div class="email-box" (click)="sendEmail()">
            <span class="send-btn" style="display:flex; flex-direction:column; align-items:center; gap:0.2rem;"><img src="{{ baseHref }}/assets/images/email/icon-send-email.svg" /><span>Send</span></span>
          </div>
        </div>
        <div class="col">
          <div class="field-row">
            <div class="field-label">From</div>
            <input class="field-input" placeholder="Choose a sender" [(ngModel)]="fromAddress" />
          </div>

          <div class="field-row">
            <div class="field-label" (click)="goToAddRecipants()" style="cursor:pointer">To</div>
            <div class="field-chips">
              <span class="email" *ngFor="let item of toArray">
                {{ getEmail(item) }}
                &nbsp;
                <span style="color: #2e308e; font-weight: bold; cursor: pointer" (click)="removeEmails(item)">x</span>
              </span>
              <span (click)="toggleBcc()" style="flex-shrink:0; margin-left:auto; font-size:0.75rem; font-weight:500; color:#2f78c4; cursor:pointer; align-self:flex-end; padding-bottom:0.2rem;">Bcc</span>
            </div>
            
          </div>

          <div class="field-row">
            <div class="field-label">CC</div>
            <input class="field-input" [(ngModel)]="ccValue" />
          </div>

          <div class="field-row" *ngIf="showBcc">
            <div class="field-label">BCC</div>
            <input class="field-input" [(ngModel)]="bcc" />
          </div>
          <!-- <div class="row-field" *ngIf="showBcc">
            <span class="label-box">Bcc</span>
            <input type="text" [(ngModel)]="bcc" />
          </div> -->
          <div class="field-row">
            <div class="field-label" style="border: none; color:#53565A; font: normal normal medium 12px/14px Gellix;">Subject</div>
            <input
              class="field-input"
              [(ngModel)]="subject"
            />
          </div>
        </div>
      </div>
    </div>

    <div style="border: 0.063rem solid #97999b; opacity: 1; width: 100%; margin-bottom: 0.625rem"></div>

    <div class="editor-wrapper">

      <div class="editor-container">
        <app-tinymce-rich-text-editor
          [editorContent]="editorContent"
          (updatedEditorContent)="editorContentHandler($event)">
        </app-tinymce-rich-text-editor>
      </div>
    
    </div>
    <!-- <div class="container-fluid" style="opacity: 1; margin-top: 0.938rem">
      <div class="container">
        <textarea
          style="width: 100%; border: none; background-color: #f6f6f6; resize: none; padding-top: 0.625rem"
        ></textarea>
      </div>
    </div> -->
  </div>
</div>

<ng-template #elsePart>
  <div style="padding: 0.938rem; display: flex; align-items: center; gap: 0.5rem;">
    <div
      style="
        width: 64px;
        height: 1.875rem;
        background: #ffffff 0% 0% no-repeat padding-box;
        border: 0.063rem solid #97999b;
        border-radius: 0.125rem;
        opacity: 1;
        flex-shrink: 0;
      "
    >
      <div (click)="goToAddRecipants()" class="container-fluid text" style="padding-top: 0.313rem">To</div>
    </div>

    <div
      class="text"
      style="
        flex: 1;
        border-bottom: 0.063rem solid #d0d0ce;
        height: 2rem;
        text-align: left;
        overflow: hidden;
      "
    >
    <span class="email" *ngFor="let item of toArray">
      {{ getEmail(item) }} &nbsp;
        <span style="color: #2e308e; font-weight: bold" (click)="removeEmails(item)">x</span></span
      >
    </div>
    <button (click)="addEmails()" class="continue-btn" style="flex-shrink: 0;" [disabled]="toArray.length === 0" [style.opacity]="toArray.length === 0 ? '0.4' : '1'" [style.cursor]="toArray.length === 0 ? 'not-allowed' : 'pointer'">
      <span
        style="
          text-align: end;
          font-weight: 600;
          font-size: 0.813rem;
          line-height: 0.938rem;
          letter-spacing: 0rem;
          color: #000048;
        "
        >Continue</span
      >
    </button>
  </div>
  <div style="padding: 1rem;">
    <app-search-dialog [isEmail]="isEmail" [hideNotFoundButton]="false"></app-search-dialog>
 </div>
  
</ng-template>


</div>